module.exports = __webpack_public_path__ + "static/media/hall-PD.8706fc0d.svg";